<!-- src\components\locales\ConsumoLocal.vue -->
<template>
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 m-1 mt-5 overflow-hidden">
        <div @click="toggleSeccion" class="flex justify-between items-center p-4 bg-gray-50/50 cursor-pointer hover:bg-gray-100 transition-colors">
            <h3 class="text-lg font-semibold text-gray-900">Consumo del Local</h3>
            <svg :class="['w-5 h-5 text-gray-500 transition-transform duration-300', seccionExpandida ? 'rotate-180' : '']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
        </div>

        <div class="m-4 mt-2">
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">Consumo Total de Energía</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold text-gray-900">{{ metricas.consumoTotalEnergia }}</span>
                        <span class="text-sm font-medium text-green-600">kWh</span>
                    </div>
                </div>

                <div @click="mostrarFiltros = !mostrarFiltros" class="bg-white rounded-lg p-4 border border-efintelwhite-55 cursor-pointer hover:bg-gray-100 transition-colors">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">Consumo Personalizado</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold text-gray-900">{{ metricas.consumoPersonalizado }}</span>
                        <span class="text-sm font-medium text-green-600">kWh</span>
                    </div>
                </div>

                <div class="bg-white rounded-lg p-4 border border-efintelwhite-55">
                    <div class="flex items-center space-x-2 mb-1">
                        <svg class="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                        </svg>
                        <p class="text-xs font-medium text-gray-500 uppercase tracking-wider">Pico de Demanda</p>
                    </div>
                    <div class="flex items-baseline space-x-1">
                        <span class="text-2xl font-bold text-gray-900">{{ metricas.peakDemanda }}</span>
                        <span class="text-sm font-medium text-green-600">kW</span>
                    </div>
                </div>
            </div>

            <div v-show="seccionExpandida" class="transition-all duration-300 p-1">
                <div v-show="mostrarFiltros" class="bg-white mb-2 mt-2">
                    <div class="flex flex-col xl:flex-row flex-wrap gap-3 items-center w-full">
                        <input v-model.lazy="filtros.fechaDesde" type="datetime-local" :disabled="cargandoFiltros" class="w-full xl:w-auto xl:flex-1 h-8 px-2 border border-gray-300 rounded-lg bg-white text-xs shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-60" />

                        <input v-model.lazy="filtros.fechaHasta" type="datetime-local" :disabled="cargandoFiltros" class="w-full xl:w-auto xl:flex-1 h-8 px-2 border border-gray-300 rounded-lg bg-white text-xs shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-60" />

                        <div class="flex flex-wrap items-center gap-1 p-1">
                            <button v-for="preset in presetsTiempo" :key="preset.horas" @click="aplicarPreset(preset)" :disabled="cargandoFiltros" class="h-7 px-2 rounded-lg text-xs font-medium bg-white border border-gray-200 text-gray-700 shadow-sm hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50">
                                {{ preset.nombre }}
                            </button>
                        </div>

                        <div class="flex items-center justify-end gap-1.5 w-full xl:w-auto xl:ml-auto">
                            <button @click="actualizarGraficoPersonalizado" :disabled="cargandoFiltros" class="h-8 px-3 rounded-lg text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition disabled:opacity-50 disabled:cursor-not-allowed">
                                {{ cargandoFiltros ? 'Cargando...' : 'Actualizar' }}
                            </button>
                            <button @click="resetFiltros" :disabled="cargandoFiltros" class="h-8 px-3 rounded-lg text-xs font-semibold text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition disabled:opacity-50 disabled:cursor-not-allowed">
                                Reset
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="cargandoGraficos" class="flex justify-center items-center py-9">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                </div>

                <div v-show="!cargandoGraficos" class="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-5">
                    <div class="bg-white p-3 flex flex-col">
                        <h4 class="text-sm font-semibold text-gray-700 mb-2">Tendencia de Energía (24h)</h4>
                        <div ref="chartTendencia" class="w-full h-[300px]"></div>
                    </div>

                    <div class="bg-white p-3 flex flex-col">
                        <h4 class="text-sm font-semibold text-gray-700 mb-2">Consumo Anual</h4>
                        <div ref="chartAnual" class="w-full h-[300px]"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
let echarts = null;
try {
    echarts = require('echarts');
} catch (error) {
    console.warn('ECharts no disponible');
}

import { markRaw } from 'vue';
import ConsumoService from '@/services/locales/consumo.js';

export default {
    name: 'ConsumoLocal',
    props: {
        localId: {
            type: [String, Number],
            required: false,
            default: null
        }
    },
    data() {
        return {
            seccionExpandida: true,
            cargandoGraficos: false,
            cargandoFiltros: false,
            graficosIniciados: false,
            mostrarFiltros: false,
            filtros: {
                fechaDesde: '',
                fechaHasta: ''
            },
            presetsTiempo: [
                { key: '1h', nombre: '1 hora', horas: 1 },
                { key: '4h', nombre: '4 horas', horas: 4 },
                { key: '24h', nombre: '24 horas', horas: 24 },
                { key: '7d', nombre: '7 días', horas: 168 },
                { key: '45d', nombre: '45 días', horas: 1080 }
            ],
            metricas: {
                consumoTotalEnergia: '0.0',
                consumoPersonalizado: '0.0',
                peakDemanda: '0.0'
            },
            instanciaChartTendencia: null,
            instanciaChartAnual: null,
            resizeObserver: null
        }
    },
    async mounted() {
        await this.cargarMetricasGenerales();
        await this.iniciarGraficos();
        this.configurarResponsividad();
    },
    beforeUnmount() {
        this.limpiarGraficos();
    },
    watch: {
        seccionExpandida(estaExpandida) {
            if (estaExpandida) {
                this.$nextTick(() => {
                    if (!this.graficosIniciados) {
                        this.iniciarGraficos();
                    } else {
                        this.redimensionarGraficos();
                    }
                });
            }
        }
    },
    methods: {
        toggleFiltros() {
            this.mostrarFiltros = !this.mostrarFiltros;
            if (this.mostrarFiltros && !this.seccionExpandida) {
                this.seccionExpandida = true;
            }
        },

        toggleSeccion() {
            this.seccionExpandida = !this.seccionExpandida;
        },

        formatearFechaLocal(fecha) {
            const tzoffset = (new Date()).getTimezoneOffset() * 60000;
            return (new Date(fecha - tzoffset)).toISOString().slice(0, 16);
        },

        aplicarPreset(preset) {
            const ahora = new Date();
            const desde = new Date(ahora.getTime() - (preset.horas * 60 * 60 * 1000));

            this.filtros.fechaHasta = this.formatearFechaLocal(ahora);
            this.filtros.fechaDesde = this.formatearFechaLocal(desde);

            this.actualizarGraficoPersonalizado();
        },

        resetFiltros() {
            this.aplicarPreset({ horas: 24 });
        },

        async actualizarGraficoPersonalizado() {
            if (!this.filtros.fechaDesde || !this.filtros.fechaHasta) return;

            this.cargandoFiltros = true;
            try {
                const datosTendencia = await ConsumoService.obtenerTendenciaEnergia(
                    this.localId,
                    this.filtros.fechaDesde,
                    this.filtros.fechaHasta
                );
                this.renderizarTendencia(datosTendencia);
            } catch (error) {
                console.error('Error al actualizar tendencia personalizada:', error);
            } finally {
                this.cargandoFiltros = false;
            }
        },

        async cargarMetricasGenerales() {
            try {
                const data = await ConsumoService.obtenerMetricasGenerales(this.localId);
                this.metricas = data;
            } catch (error) {
                console.error('Error al cargar métricas:', error);
            }
        },

        async iniciarGraficos() {
            if (!echarts) return;
            this.cargandoGraficos = true;

            try {
                const [datosTendencia, datosAnuales] = await Promise.all([
                    ConsumoService.obtenerTendenciaEnergia(this.localId),
                    ConsumoService.obtenerConsumoAnual(this.localId)
                ]);

                this.renderizarTendencia(datosTendencia);
                this.renderizarAnual(datosAnuales);
                this.graficosIniciados = true;
            } catch (error) {
                console.error('Error al cargar datos de gráficos:', error);
            } finally {
                this.cargandoGraficos = false;
            }
        },

        renderizarTendencia(datos) {
            if (!this.$refs.chartTendencia) return;

            const chart = echarts.init(this.$refs.chartTendencia);
            this.instanciaChartTendencia = markRaw(chart);

            const tiempos = datos.map(d => d.tiempo);

            const options = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'cross' }
                },
                legend: {
                    data: ['Total Local', 'HVAC 1', 'HVAC 2', 'Temp. Interior', 'Temp. Exterior'],
                    bottom: 0,
                    textStyle: { fontSize: 11 }
                },
                grid: { left: '3%', right: '4%', bottom: '12%', top: '18%', containLabel: true },
                xAxis: {
                    type: 'category',
                    data: tiempos,
                    axisLabel: { rotate: 45, fontSize: 10 }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'Potencia (kW)',
                        position: 'left',
                        axisLine: { show: true, lineStyle: { color: '#3b82f6' } },
                        splitLine: { lineStyle: { type: 'dashed' } }
                    },
                    {
                        type: 'value',
                        name: 'Temperatura (°C)',
                        position: 'right',
                        axisLine: { show: true, lineStyle: { color: '#ef4444' } },
                        splitLine: { show: false }
                    }
                ],
                series: [
                    {
                        name: 'Total Local',
                        type: 'line',
                        data: datos.map(d => d.potenciaTotal),
                        yAxisIndex: 0,
                        itemStyle: { color: '#3b82f6' },
                        lineStyle: { width: 3 },
                        symbol: 'none'
                    },
                    {
                        name: 'HVAC 1',
                        type: 'line',
                        data: datos.map(d => d.potenciaHVAC1),
                        yAxisIndex: 0,
                        itemStyle: { color: '#8b5cf6' },
                        lineStyle: { width: 2, type: 'dashed' },
                        symbol: 'none'
                    },
                    {
                        name: 'HVAC 2',
                        type: 'line',
                        data: datos.map(d => d.potenciaHVAC2),
                        yAxisIndex: 0,
                        itemStyle: { color: '#10b981' },
                        lineStyle: { width: 2, type: 'dashed' },
                        symbol: 'none'
                    },
                    {
                        name: 'Temp. Interior',
                        type: 'line',
                        data: datos.map(d => d.tempInterior),
                        yAxisIndex: 1,
                        itemStyle: { color: '#f59e0b' },
                        smooth: true,
                        symbol: 'none'
                    },
                    {
                        name: 'Temp. Exterior',
                        type: 'line',
                        data: datos.map(d => d.tempExterior),
                        yAxisIndex: 1,
                        itemStyle: { color: '#ef4444' },
                        smooth: true,
                        symbol: 'none'
                    }
                ]
            };

            this.instanciaChartTendencia.setOption(options);
        },

        renderizarAnual(datos) {
            if (!this.$refs.chartAnual) return;

            const chart = echarts.init(this.$refs.chartAnual);
            this.instanciaChartAnual = markRaw(chart);

            const options = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                grid: { left: '3%', right: '4%', bottom: '12%', top: '18%', containLabel: true },
                xAxis: {
                    type: 'category',
                    data: datos.map(d => d.mes),
                    axisLabel: { fontSize: 11 }
                },
                yAxis: {
                    type: 'value',
                    name: 'Consumo (kWh)',
                    splitLine: { lineStyle: { type: 'dashed' } }
                },
                series: [
                    {
                        name: 'Consumo',
                        type: 'bar',
                        data: datos.map(d => d.consumo),
                        itemStyle: {
                            color: '#3b82f6',
                            borderRadius: [4, 4, 0, 0]
                        }
                    }
                ]
            };

            this.instanciaChartAnual.setOption(options);
        },

        configurarResponsividad() {
            if (window.ResizeObserver) {
                this.resizeObserver = new ResizeObserver(() => {
                    this.redimensionarGraficos();
                });
                this.resizeObserver.observe(this.$el);
            }
            window.addEventListener('resize', this.redimensionarGraficos);
        },

        redimensionarGraficos() {
            if (this.instanciaChartTendencia) this.instanciaChartTendencia.resize();
            if (this.instanciaChartAnual) this.instanciaChartAnual.resize();
        },

        limpiarGraficos() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
            window.removeEventListener('resize', this.redimensionarGraficos);

            if (this.instanciaChartTendencia) {
                this.instanciaChartTendencia.dispose();
            }
            if (this.instanciaChartAnual) {
                this.instanciaChartAnual.dispose();
            }
        }
    }
}
</script>

<style scoped>
.animate-spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.transition-colors {
    transition-property: background-color, border-color, color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
</style>